import { createSlice } from '@reduxjs/toolkit';
import { receiveDocumentHeaders } from '../actions';

export interface DocumentHeadersState {
  hasLastModifiedChanged: boolean;
  lastModified: string | null;
  date: string | null;
}

const initialState: DocumentHeadersState = {
  hasLastModifiedChanged: false,
  lastModified: null,
  date: null,
};

const documentHeadersSlice = createSlice({
  name: 'documentHeaders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(receiveDocumentHeaders, (state, action) => {
      const { lastModified, date } = action.payload;
      // Compute the flag against the previous lastModified before overwriting it.
      state.hasLastModifiedChanged =
        state.hasLastModifiedChanged ||
        (!!lastModified &&
          !!state.lastModified &&
          lastModified !== state.lastModified);
      state.lastModified = lastModified;
      state.date = date;
    });
  },
});

export const documentHeadersReducer = documentHeadersSlice.reducer;
